import { connect } from 'react-redux';
import EventsView from './index'
import {loadEvents, removeEvent, updateEvent} from '../../actions/Events'
import {parse} from 'querystringify';
import moment from 'moment'
const mapStateToProps = (state, props) => {
    const filterEvents = () => {
	const search = parse(props.location.search);
	if(state.events.list){
	    if(search.only === 'news')
		return state.events.list.filter((e) => !e.category)
	    else if(search.period){
		return state.events.list.filter((e) => moment(e.event_on).format("YYYY/MM/DD") == search.period)
	    }
	    
	    else
		return state.events.list
	}
    }

    
    return {
	events: filterEvents(),
	authenticated: state.session.authenticated
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	loadEvents: () => {
	    return dispatch(loadEvents());
	},
	removeEvent: (event) => {
	    return dispatch(removeEvent(event)).then(() => dispatch(loadEvents()));
	},
	updateEvent: (event) => {
	    return dispatch(updateEvent(event)).then(() => dispatch(loadEvents()));
	}
	
    }
}

const EventsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(EventsView);




export default EventsContainer;



// WEBPACK FOOTER //
// ./src/components/Events/Container.js